import { Directive, TemplateRef, inject, output } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[carouselItem]',
})
export class CarouselItemDirective {
  tpl = inject<TemplateRef<unknown>>(TemplateRef);

  readonly lazyLoad = output<void>();
}
